const STATUS = {
	ERROR: 'ERROR',
  	FETCHING: 'FETCHING',
  	FETCHED: 'FETCHED',
  	UNFETCHED: 'UNFETCHED',
};

export default STATUS;